var getOrCreateLegendList = function (chart, id) {
    var legendContainer = document.getElementById(id);
    var listContainer = legendContainer.querySelector("ul");
    if (!listContainer) {
        listContainer = document.createElement("ul");
        listContainer.style.display = "flex";
        listContainer.style.flexDirection = "row";
        listContainer.style.margin = 0;
        listContainer.style.padding = 0;
        legendContainer.appendChild(listContainer);
    }
    return listContainer;
};
export default function getCustomLegend(props) {
    var customLegend = {
        id: "htmlLegend",
        afterUpdate: function (chart, args, options) {
            var ul = getOrCreateLegendList(chart, options.containerID);
            ul.style.justifyContent = "center";
            // Remove old legend items
            while (ul.firstChild) {
                ul.firstChild.remove();
            }
            // Reuse the built-in legendItems generator
            var items = chart.options.plugins.legend.labels.generateLabels(chart);
            items.forEach(function (item) {
                var li = document.createElement("li");
                li.style.alignItems = "center";
                li.style.cursor = "pointer";
                li.style.display = "flex";
                li.style.flexDirection = "row";
                li.style.marginLeft = "5px";
                li.onclick = function () {
                    var type = chart.config.type;
                    if (type === "pie" || type === "doughnut") {
                        // Pie and doughnut charts only have a single dataset and visibility is per item
                        chart.toggleDataVisibility(item.index);
                    }
                    else {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                    }
                    chart.update();
                };
                // Color box
                var boxSpan = document.createElement("span");
                boxSpan.style.background = item.fillStyle;
                boxSpan.style.borderColor = item.strokeStyle;
                boxSpan.style.borderWidth = item.lineWidth + "px";
                boxSpan.style.display = "inline-block";
                boxSpan.style.height = "12px";
                boxSpan.style.width = "12px";
                boxSpan.style.marginRight = "4px";
                boxSpan.style.borderRadius = "100px";
                // Text
                var textContainer = document.createElement("p");
                textContainer.style.color = item.fontColor;
                textContainer.style.margin = 0;
                textContainer.style.padding = 0;
                textContainer.style.fontSize = (props === null || props === void 0 ? void 0 : props.fontSize) || "12px";
                textContainer.style.textDecoration = item.hidden ? "line-through" : "";
                var text = document.createTextNode(item.text);
                textContainer.appendChild(text);
                li.appendChild(boxSpan);
                li.appendChild(textContainer);
                ul.appendChild(li);
            });
        },
    };
    return customLegend;
}
var getOrCreateLegendListColumnWise = function (chart, id) {
    var legendContainer = document.getElementById(id);
    var listContainer = legendContainer.querySelector("ul");
    if (!listContainer) {
        listContainer = document.createElement("ul");
        listContainer.style.display = "flex";
        listContainer.style.flexDirection = "column";
        listContainer.style.margin = 0;
        listContainer.style.padding = 0;
        legendContainer.appendChild(listContainer);
    }
    return listContainer;
};
export function getCustomLegendColumnWise(props) {
    var customLegend = {
        id: "htmlLegend",
        afterUpdate: function (chart, args, options) {
            var ul = getOrCreateLegendListColumnWise(chart, options.containerID);
            ul.style.justifyContent = "center";
            // Remove old legend items
            while (ul.firstChild) {
                ul.firstChild.remove();
            }
            // Reuse the built-in legendItems generator
            var items = chart.options.plugins.legend.labels.generateLabels(chart);
            items.forEach(function (item) {
                var li = document.createElement("li");
                li.style.alignItems = "center";
                li.style.cursor = "pointer";
                li.style.display = "flex";
                li.style.flexDirection = "row";
                li.style.marginLeft = "5px";
                li.onclick = function () {
                    var type = chart.config.type;
                    if (type === "pie" || type === "doughnut") {
                        // Pie and doughnut charts only have a single dataset and visibility is per item
                        chart.toggleDataVisibility(item.index);
                    }
                    else {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                    }
                    chart.update();
                };
                // Color box
                var boxSpan = document.createElement("span");
                boxSpan.style.background = item.fillStyle;
                boxSpan.style.borderColor = item.strokeStyle;
                boxSpan.style.borderWidth = item.lineWidth + "px";
                boxSpan.style.display = "inline-block";
                boxSpan.style.height = "12px";
                boxSpan.style.width = "12px";
                boxSpan.style.marginRight = "4px";
                boxSpan.style.borderRadius = "100px";
                // Text
                var textContainer = document.createElement("p");
                textContainer.style.color = item.fontColor;
                textContainer.style.margin = 0;
                textContainer.style.padding = 0;
                textContainer.style.fontSize = (props === null || props === void 0 ? void 0 : props.fontSize) || "12px";
                textContainer.style.textDecoration = item.hidden ? "line-through" : "";
                var text = document.createTextNode(item.text);
                textContainer.appendChild(text);
                li.appendChild(boxSpan);
                li.appendChild(textContainer);
                ul.appendChild(li);
            });
        },
    };
    return customLegend;
}
